import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { Progress } from '../../ui/progress';
import { 
  Play, 
  Pause, 
  SkipForward,
  SkipBack,
  Volume2,
  VolumeX
} from 'lucide-react';

/**
 * Audio player controls for the lesson
 */
export const LessonPlayer = ({ 
  currentSection,
  currentSectionIndex,
  totalSections,
  progressPct,
  isPlaying,
  isMuted,
  onTogglePlay,
  onPrevSection,
  onNextSection,
  onToggleMute
}) => {
  return (
    <>
      {/* Section Info */}
      <div className="text-center mb-6">
        <p className="text-sm text-muted-foreground mb-1">
          Section {currentSectionIndex + 1} of {totalSections}
        </p>
        <h2 className="text-xl font-semibold">{currentSection?.title}</h2>
        {currentSection?.key_points?.length > 0 && (
          <div className="flex flex-wrap justify-center gap-2 mt-2">
            {currentSection.key_points.map((point, i) => (
              <Badge key={`point-${i}`} variant="outline" className="text-xs">
                {point}
              </Badge>
            ))}
          </div>
        )}
      </div>

      {/* Progress Bar */}
      <Progress value={progressPct} className="h-2 mb-6" />

      {/* Controls */}
      <div className="flex items-center justify-center gap-4">
        <Button
          variant="outline"
          size="icon"
          onClick={onPrevSection}
          disabled={currentSectionIndex === 0}
          data-testid="lesson-prev-btn"
        >
          <SkipBack className="h-5 w-5" />
        </Button>
        
        <Button
          size="lg"
          className="w-16 h-16 rounded-full bg-gradient-to-r from-cyan-600 to-blue-600"
          onClick={onTogglePlay}
          data-testid="lesson-play-btn"
        >
          {isPlaying ? (
            <Pause className="h-8 w-8" />
          ) : (
            <Play className="h-8 w-8 ml-1" />
          )}
        </Button>
        
        <Button
          variant="outline"
          size="icon"
          onClick={onNextSection}
          disabled={currentSectionIndex === totalSections - 1}
          data-testid="lesson-next-btn"
        >
          <SkipForward className="h-5 w-5" />
        </Button>

        <Button
          variant="ghost"
          size="icon"
          onClick={onToggleMute}
          data-testid="lesson-mute-btn"
        >
          {isMuted ? <VolumeX className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}
        </Button>
      </div>
    </>
  );
};

export default LessonPlayer;
